import { useEffect, useState } from 'react';
import { useSpinDelay } from 'spin-delay';

import { Spinner } from '~components/generic/spinner/Spinner';
import useAppSelector from '~hooks/useAppSelector';
import { useLabel } from '~hooks/useLabels';
import { selectAddonsIsMediaLibraryEnabled } from '~store/selectors';

export function SearchResultHeader({ numFound = 0, isLoading = false }: { numFound?: number; isLoading?: boolean }) {
  const isMediaLibraryEnabled = useAppSelector(selectAddonsIsMediaLibraryEnabled);

  const [label, setLabel] = useState<string>(undefined);

  // Labels
  const numFoundLable = useLabel('labelSearchResultsFound', { numFound });
  const mediaLibraryEmptyLabel = useLabel('labelContentSearchEmpty');

  useEffect(() => {
    setLabel(isMediaLibraryEnabled && numFound === 0 ? mediaLibraryEmptyLabel : numFoundLable);
  }, [isMediaLibraryEnabled, mediaLibraryEmptyLabel, numFound, numFoundLable]);

  // Derived values
  const showSpinner = useSpinDelay(isLoading);

  return (
    <div className="ebm--result-header my-2">
      <div className="relative flex items-center justify-between mx-auto max-w-screen-xl bg-opacity-100">
        <div className="select-none">{showSpinner ? <Spinner /> : label}</div>
      </div>
    </div>
  );
}
